import type React from "react";

/**
 * App branding configuration
 * Centralized location for app name, logo, and other branding elements
 */
export const AppBranding = {
  name: "Pocket Teacher",
  tagline: "Better English. Brighter Future.",
  logo: (<h1 className="h4">Pocket Teacher</h1>) as React.ReactNode,
};
